<template>
  <AuthenticatedLayout>
    <CategoriasTable />
  </AuthenticatedLayout>
</template>

<script>
import AuthenticatedLayout from "@/components/AuthenticatedLayout.vue";
import CategoriasTable from "@/views/components/CategoriasTable.vue";

export default {
  name: "Categorias",
  components: {
    AuthenticatedLayout,
    CategoriasTable,
  },
};
</script>
